
import axios, { AxiosResponse } from 'axios';
import { KIT_API_BASE_URL, X_OWNER } from '../../constants';
import { KitActivateFormPayload, KitActivateFormResponse, KitResponse } from '../../models/kit';

export default class ProfileService {

  static async getKitStatus() {
    const response: AxiosResponse<KitResponse[]> = await axios.get(`${KIT_API_BASE_URL}/v1.0/status`);
    return response.data;
  }

  static async activateKit(payload: KitActivateFormPayload) {
    const owner = payload.owner || payload.partner;
    const partner = payload.partner;
    const response: AxiosResponse<KitActivateFormResponse> = await axios.put(`${KIT_API_BASE_URL}/v1.0/barcode/${payload.code}/profile?partner=${partner}`, { profileId: payload.profileId }, { headers: { [X_OWNER]: `${owner}` } });
    return response.data;
  }
}